import { Component, computed, input, output } from '@angular/core';
import { MaintenancePopupVm } from '@infrastructure/maintenance';

@Component({
  selector: 'app-maintenance-popup',
  templateUrl: './maintenance-popup.component.html',
})
export class MaintenancePopupComponent {
  readonly popup = input.required<MaintenancePopupVm>();
  readonly retrying = input(false);

  readonly retryRequested = output<void>();
  readonly dismissRequested = output<void>();

  protected readonly retryHint = computed(() => {
    const seconds = this.popup().retryAfterSeconds;
    if (typeof seconds !== 'number' || seconds <= 0) {
      return '';
    }

    const minutes = Math.ceil(seconds / 60);
    return minutes <= 1 ? 'Рекомендуем повторить через минуту.' : `Рекомендуем повторить через ${minutes} мин.`;
  });

  protected onRetry(): void {
    if (this.retrying()) {
      return;
    }

    this.retryRequested.emit();
  }

  protected onDismiss(): void {
    this.dismissRequested.emit();
  }
}
